let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8Y9JE")).then(() => parcelRequire('1zktf'));